import { render, staticRenderFns } from "./reisetermin-view-basisdaten.vue?vue&type=template&id=15c8b4b5"
import script from "./reisetermin-view-basisdaten.vue?vue&type=script&lang=js"
export * from "./reisetermin-view-basisdaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports